import { useQuery } from '@tanstack/react-query';
import { getComplaint, type ComplaintDetailResponse } from '../api';

/**
 * Hook to fetch a single complaint with its history
 * @param complaintId - The complaint ID to fetch
 * @param enabled - Whether to fetch the complaint (default: true)
 */
export function useComplaint(complaintId: string | undefined, enabled = true) {
  return useQuery({
    queryKey: ['complaint', complaintId],
    queryFn: (): Promise<ComplaintDetailResponse> => getComplaint(complaintId!),
    enabled: enabled && !!complaintId,
    staleTime: 30 * 1000, // 30 seconds
  });
}
